import { useCallback, useEffect, useState } from 'react';
import Button from '../../../components/BaseComponents/Button';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import UpdateBodySystemModal from './UpdateBodySystemModal';
import EditBodySystemPromptsModal from './EditBodySystemPromptsModal';
import {
  changeUpdateBodySystemModalVisibility,
  setBodySystemsList,
  setBodySystemToEdit,
  setBsCount,
} from '../../../store/appSlice';
import { getBodySystemsList } from '../../../api/body-systems';
import {
  BodySystemPromptField,
  ListBodySystemResponseElement,
} from '../../../types/apiGeneratedTypes';
import BodySystemsTable from './BodySystemsTable';
import GenerateBodySystemForMembersModal from './GenerateBodySystemForMembersModal';
import './BodySystemsTab.scss';

type PromptEditTarget = {
  bodySystem: ListBodySystemResponseElement;
  field: BodySystemPromptField;
};

const BodySystems = () => {
  const dispatch = useDispatch();
  const { isUpdateBodySystemModalOpened, bsCount } = useSelector(
    (state: RootState) => state.app
  );
  const [promptEditTarget, setPromptEditTarget] = useState<PromptEditTarget | null>(null);
  const [generateTarget, setGenerateTarget] = useState<ListBodySystemResponseElement | null>(
    null
  );

  const refreshBodySystems = useCallback(async () => {
    const response = await getBodySystemsList({ prompt: true });
    dispatch(setBodySystemsList(response.body_systems));
    dispatch(setBsCount(response.body_systems.length));
  }, [dispatch]);

  useEffect(() => {
    refreshBodySystems().catch((error) => {
      console.log('Error loading body systems with prompts', error);
    });
  }, [refreshBodySystems]);

  const onAddBodySystemBtnClick = () => {
    dispatch(setBodySystemToEdit(null));
    dispatch(changeUpdateBodySystemModalVisibility(true));
  };

  const onCloseUpdateBodySystemModal = () => {
    dispatch(changeUpdateBodySystemModalVisibility(false));
    dispatch(setBodySystemToEdit(null));
  };

  return (
    <>
      <div className='search-row-container'>
        <div className='search-and-filter-container'>
          <div className='count-container'>
            {bsCount} {bsCount === 1 ? 'body system' : 'body systems'}
          </div>
        </div>
        <Button
          isSecondary={true}
          text='Add body system'
          onClick={onAddBodySystemBtnClick}
        />
      </div>

      <div className='body-systems-container'>
        {isUpdateBodySystemModalOpened && (
          <UpdateBodySystemModal
            isOpen={isUpdateBodySystemModalOpened}
            onClose={onCloseUpdateBodySystemModal}
          />
        )}
        {promptEditTarget && (
          <EditBodySystemPromptsModal
            isOpen={Boolean(promptEditTarget)}
            bodySystem={promptEditTarget.bodySystem}
            field={promptEditTarget.field}
            onClose={() => setPromptEditTarget(null)}
            onSaved={refreshBodySystems}
          />
        )}
        {generateTarget && (
          <GenerateBodySystemForMembersModal
            isOpen={Boolean(generateTarget)}
            bodySystem={generateTarget}
            onClose={() => setGenerateTarget(null)}
          />
        )}
        <BodySystemsTable
          onEditPrompt={(bodySystem, field) =>
            setPromptEditTarget({ bodySystem, field })
          }
          onGenerateScores={setGenerateTarget}
        />
      </div>
    </>
  );
};

export default BodySystems;
